import { Check, Info, Link2, MoreVertical, RotateCcw, Trash2 } from "lucide-react";
import type { Mention } from "@/shared/types/mention";

/**
 * O "⋮" de uma menção: revisar, vincular a outra marca, descartar ou
 * restaurar. Mora num arquivo próprio desde 2026-10-13 porque a lista e
 * o Modo revisão usam o mesmo menu.
 */
export type MentionActionsMenuProps = {
  mention: Mention;
  isOpen: boolean;
  triggerSize?: number;
  onToggle: () => void;
  /** Ausente = sem "Mais informações" no menu: na visão Lista quem mostra
   *  os detalhes é a seta do próprio card (2026-10-13). */
  onInfo?: () => void;
  /** Descartar (ou restaurar, quando a menção já está descartada) —
   *  o "excluir" da galera de negócio. Descartar abre a confirmação
   *  (decisão da dona, 2026-10-18); restaurar é imediato. */
  onDiscardToggle: () => void;
  /** Marcar (ou desmarcar) como revisada. */
  onReviewToggle: () => void;
  /** Vincular a publicação a outra marca, à mão. */
  onLink: () => void;
};

export function MentionActionsMenu({
  mention,
  isOpen,
  triggerSize = 16,
  onToggle,
  onInfo,
  onDiscardToggle,
  onReviewToggle,
  onLink,
}: MentionActionsMenuProps) {
  return (
    <div className="mention-actions">
      <button
        type="button"
        className="mention-actions-trigger mention-data-tooltip"
        aria-label={`Ações da menção de ${mention.source}`}
        data-tooltip="Ações"
        data-tooltip-position="bottom"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <MoreVertical size={triggerSize} />
      </button>
      {isOpen && (
        <div className="mention-action-menu" role="menu">
          {onInfo && (
            <button type="button" role="menuitem" onClick={onInfo}>
              <Info size={14} />
              Mais informações
            </button>
          )}
          {!mention.discardedAt && (
            <button type="button" role="menuitem" onClick={onReviewToggle}>
              <Check size={14} />
              {mention.reviewedAt ? "Desmarcar revisão" : "Marcar como revisada"}
            </button>
          )}
          {!mention.discardedAt && (
            <button type="button" role="menuitem" onClick={onLink}>
              <Link2 size={14} />
              Vincular a outra marca
            </button>
          )}
          {mention.discardedAt ? (
            <button type="button" role="menuitem" onClick={onDiscardToggle}>
              <RotateCcw size={14} />
              Restaurar
            </button>
          ) : (
            <button type="button" role="menuitem" className="danger" onClick={onDiscardToggle}>
              <Trash2 size={14} />
              Descartar
            </button>
          )}
        </div>
      )}
    </div>
  );
}
